import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bbf79f6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "touchtable" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", {
  id: "canvas",
  class: "touchcanvas"
}, null, -1))
const _hoisted_3 = { class: "font-bold text-4xl mb-12" }
const _hoisted_4 = {
  key: 0,
  class: "text-xl mb-12"
}
const _hoisted_5 = {
  key: 1,
  class: "text-xl mb-12"
}
const _hoisted_6 = { class: "flex w-full flex-wrap justify-center items-center mt-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inactivity_modal = _resolveComponent("inactivity-modal")!
  const _component_basket_overlay = _resolveComponent("basket-overlay")!
  const _component_shutdown_modal = _resolveComponent("shutdown-modal")!
  const _component_media_modal = _resolveComponent("media-modal")!
  const _component_touch_header = _resolveComponent("touch-header")!
  const _component_on_boarding_card = _resolveComponent("on-boarding-card")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_CardComponent = _resolveComponent("CardComponent")!
  const _component_relationBrowser = _resolveComponent("relationBrowser")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_inactivity_modal),
    _createVNode(_component_basket_overlay, { boxVisitorCode: _ctx.code }, null, 8, ["boxVisitorCode"]),
    _createVNode(_component_shutdown_modal, {
      code: _ctx.code,
      onDisposeCanvas: _ctx.disposeCanvas
    }, null, 8, ["code", "onDisposeCanvas"]),
    _createVNode(_component_media_modal),
    _createVNode(_component_touch_header, {
      "basket-amount": _ctx.BasketOverlayState.overlayItems.length
    }, null, 8, ["basket-amount"]),
    _createElementVNode("div", null, [
      _createVNode(_component_on_boarding_card, {
        showCard: 
          _ctx.onBoardingState.status == 'started' &&
          _ctx.onBoardingState.currentStepName == 'lookAtOtherPictures'
            ? true
            : false
        ,
        cardTitle: _ctx.t('touchtable.onBoarding.lookAtOtherPictures.title'),
        cardDescription: _ctx.t('touchtable.onBoarding.lookAtOtherPictures.description'),
        placement: "right",
        distance: -500
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["showCard", "cardTitle", "cardDescription"])
    ]),
    (_ctx.entity)
      ? (_openBlock(), _createBlock(_component_CardComponent, {
          key: 0,
          "side-strip": true,
          large: true,
          reverseColors: true,
          scroll: true,
          class: "infocard"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.entity.title[0].value), 1),
            (_ctx.entity.description.length && _ctx.entity.description[0].value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.entity.description[0].value), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.t('touchtable.network.infoCard.noDescription')), 1)),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_base_button, {
                class: "text-xl",
                "custom-style": "touchtable-black",
                "custom-icon": "zoomIn",
                "icon-shown": true,
                text: 
            _ctx.entity.mediafiles[0].mediatype.image
              ? _ctx.t('touchtable.network.infoCard.buttons.zoom.image')
              : _ctx.entity.mediafiles[0].mediatype.video
              ? _ctx.t('touchtable.network.infoCard.buttons.zoom.video')
              : _ctx.t('touchtable.network.infoCard.buttons.zoom.other')
          ,
                onClick: _ctx.showPictureModal
              }, null, 8, ["text", "onClick"]),
              _createVNode(_component_on_boarding_card, {
                showCard: 
            _ctx.onBoardingState.status == 'started' &&
            _ctx.onBoardingState.currentStepName == 'fillStoryBasket'
              ? true
              : false
          ,
                cardTitle: _ctx.t('touchtable.onBoarding.fillStoryBasket.title'),
                cardDescription: _ctx.t('touchtable.onBoarding.fillStoryBasket.description'),
                placement: "right",
                distance: 10
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_button, {
                    class: "text-xl",
                    "custom-style": "touchtable-purple",
                    "custom-icon": "archiveDrawer",
                    "icon-shown": true,
                    text: _ctx.t('touchtable.network.infoCard.buttons.add'),
                    onClick: _ctx.addToBasket
                  }, null, 8, ["text", "onClick"])
                ]),
                _: 1
              }, 8, ["showCard", "cardTitle", "cardDescription"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.relationsArray)
      ? (_openBlock(), _createBlock(_component_relationBrowser, {
          key: 1,
          relations: _ctx.relationsArray,
          loading: _ctx.loading,
          onSelected: _ctx.highlightSelectedFilter
        }, null, 8, ["relations", "loading", "onSelected"]))
      : _createCommentVNode("", true)
  ]))
}